import type {
  EditorSDK,
  Logger,
  DataSettingsManager,
} from '@wix/wix-data-client-common-standalone'

export const updateDataModeValues = ({
  dataMode,
  editorSdkProxy,
  logger,
}: {
  dataMode: boolean
  editorSdkProxy: EditorSDK
  logger: Logger
}) => {
  logger.updateContext({ tags: { dataMode } })
  return editorSdkProxy.editor.updateAppState({
    dataMode,
  })
}

export const enableDataMode = async ({
  dataSettingsManager,
  logger,
}: {
  dataSettingsManager: DataSettingsManager
  logger: Logger
}) => {
  logger.breadcrumb({
    category: 'dataMode',
    message: 'Attempting to enable',
  })
  try {
    await dataSettingsManager.updateDataSettings({
      contentManagerEnabled: true,
    })
  } catch (cause) {
    logger.error(new Error('Failed to update data settings', { cause }))
  }
}

export const initializeDataSettings = async ({
  dataSettingsManager,
  logger,
}: {
  dataSettingsManager: DataSettingsManager
  logger: Logger
}) => {
  try {
    logger.breadcrumb({
      category: 'dataMode',
      message: 'Attempting to read',
    })
    await dataSettingsManager.initialize()
  } catch (cause) {
    logger.error(new Error('Failed to initialize data settings', { cause }))
  }
}

export const isDataModeEnabled = (dataSettingsManager: DataSettingsManager) =>
  dataSettingsManager.getDataSettings().contentManagerEnabled
